import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/$orgId/jobs/")({
  beforeLoad: () => {
    throw redirect({ to: "/org/providers" });
  },
});
